module.exports = __webpack_public_path__ + "static/media/photo169.22cb0353.jpg";